module.exports = __webpack_public_path__ + "img/pic_app_guarantee.8cad8a97.jpg";